@use "foundation/_colors.scss";

:share {
  primaryBrandColor: colors.$primary-brand-color;
  secondaryBrandColor: colors.$secondary-brand-color;
  tertiaryBrandColor: colors.$tertiary-brand-color;
  quaternaryBrandColor: colors.$quaternary-brand-color;
  quinaryBrandColor: colors.$quinary-brand-color;
  senaryBrandColor: colors.$senary-brand-color;
  septenaryBrandColor: colors.$septenary-brand-color;
  makerBrandColor: colors.$maker-brand-color;
  primaryBrandContrastColor: colors.$primary-brand-contrast-color;
  primaryTextColor: colors.$primary-text-color;
  secondaryTextColor: colors.$secondary-text-color;
  tertiaryTextColor: colors.$tertiary-text-color;
  quaternaryTextColor: colors.$quaternary-text-color;
  primaryBackgroundColor: colors.$primary-background-color;
  secondaryBackgroundColor: colors.$secondary-background-color;
  tertiaryBackgroundColor: colors.$tertiary-background-color;
  quaternaryBackgroundColor: colors.$quaternary-background-color;
  dividerBorderColor: colors.$divider-border-color;
  inputBorderColor: colors.$input-border-color;
  disabledFieldsetBorderColor: colors.$disabled-fieldset-border-color;
  successColor: colors.$success-color;
  errorColor: colors.$error-color;
  highlightColor: colors.$highlight-color;
  inputBackgroundColor: colors.$input-background-color;
  iftttNextAlternateBrandColor: colors.$ifttt-next-alternate-brand-color;
  iftttNextDarkBgTextColor: colors.$ifttt-next-dark-bg-text-color;
  testSuccessColor: colors.$test-success-color;
  testFailureColor: colors.$test-failure-color;
  lightOverlayColor: colors.$light-overlay-color;
  darkOverlayColor: colors.$dark-overlay-color;
  knobAltBrandColor: colors.$knob-alt-brand-color;
  connectButtonLoadingColor: colors.$connect-button-loading-color;
  white: colors.$white;
  day: colors.$day;
  wrapUp: colors.$wrap-up;
  goodEvening: colors.$good-evening;
  dawn: colors.$dawn;
  midnight: colors.$midnight;
}
